import React from "react";
import BlogsHero from "../Components/BlogsHero/BlogsHero";
import BlogsCards from "../Components/BlogsCards/BlogsCards";


const Blogs = () => {
  return (
    <>
      <BlogsHero />
      <BlogsCards />
     
      {/* Your remaining About Page sections here */}
    </>
  );
};

export default Blogs;
